import React from "react";
import { Box, Typography } from "@mui/material";

const RecaptchaDisclaimer = () => {
	return (
		<Box mt={2} className={"recaptcha-disclaimer"}>
			<Typography color={"textSecondary"}>
				This site is protected by reCAPTCHA and the Google
				<a href="https://policies.google.com/privacy" target={"_blank"} rel={"noreferrer"}>
					Privacy Policy
				</a>
				and
				<a href="https://policies.google.com/terms" target={"_blank"} rel={"noreferrer"}>
					Terms of Service
				</a>
				apply.
			</Typography>
		</Box>
	);
};

export default RecaptchaDisclaimer;
